// tslint:disable:no-any (autogenerated)
import BaseAction from '../../components/base/base-action';

export interface IMessageOptions {
    isHtml?: boolean;
    timeout?: number;
    priority?: number;
    id?: string;
    allowClose?: boolean;
    children?: any;
}

class PopupNotificationsActions extends BaseAction {
    public dispatchEventName: string = 'setPopupMessagesLayer';

    // tslint:disable-next-line:typedef (autogenerated)
    public showMessage(message: string, options?: IMessageOptions) {
        const newOptions = options || {};
        const notification: any = {
            message,
            id: typeof newOptions.id === 'string' ? newOptions.id : message,
            isHtml: typeof newOptions.isHtml === 'boolean' ? newOptions.isHtml : false,
            timeout: typeof newOptions.timeout === 'number' ? newOptions.timeout : 5000,
            priority: typeof newOptions.priority === 'number' ? newOptions.priority : 100,
            allowClose: typeof newOptions.allowClose === 'boolean' ? newOptions.allowClose : true,
            children: (options && options.children) || null
        };
        this.dispatch({ messages: [notification] });
    }

    // tslint:disable-next-line:typedef (autogenerated)
    public hideMessage(messageId: string) {
        this.dispatch({ messages: [{ id: messageId, hide: true }] });
    }

    /**
     * @deprecated
     * use showMessage instead
     * @param message
     */

    // tslint:disable-next-line:typedef (autogenerated)
    public push(message: string) {
        this.showMessage(message);
    }
}

const actions = new PopupNotificationsActions();
// tslint:disable-next-line:no-default-export (autogenerated)
export default actions;
